import { PAYMENTS_API_URL } from 'data/constants';
import { Deposit } from 'data/payments/models';
import { parseItemStrict } from 'utils/parser/parseResponse';

export async function setPaymentName(body: {
  depositId: string;
  payerName: string;
}) {
  const result = await fetch(`${PAYMENTS_API_URL}/public/payments/name`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (result.status > 399) {
    const responseBody = await result.text();
    throw new Error(`Failed to set payment name: ${responseBody}`);
  }

  // Must go below previous response reading (in case of error)
  const data = await result.json();

  return parseItemStrict(Deposit, data);
}
